// Shared "Ink" styles for pages rebuilt on the redesign (Members & Roles,
// Network Map). Colours come from the --surf-* / --ink-* tokens in index.css
// so light and dark themes both work without per-component branching.

export const monoLabel = 'font-mono text-[10.5px] tracking-[0.12em]';

export const primaryBtn = 'h-11 inline-flex items-center justify-center gap-2 px-[18px] rounded-[10px] text-sm font-semibold transition-opacity disabled:opacity-50 disabled:cursor-not-allowed';
export const primaryBtnStyle = { background: 'var(--accent)', color: '#0A0A0A' };

export const secondaryBtn = 'h-11 inline-flex items-center justify-center gap-2 px-4 rounded-[10px] border text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
export const secondaryBtnStyle = { background: 'transparent', color: 'var(--ink-text)', borderColor: 'var(--surf-line-strong)' };

export const ghostBtn = 'h-11 inline-flex items-center justify-center px-4 rounded-[10px] text-sm font-medium';
export const ghostBtnStyle = { background: 'transparent', color: 'var(--ink-muted)' };

export const inputCls = 'h-11 w-full box-border px-3 rounded-[10px] border text-sm outline-none focus:border-[color:var(--accent)] disabled:opacity-60';
export const inputStyle = { background: 'var(--surf-bg)', borderColor: 'var(--surf-line-strong)', color: 'var(--ink-text)' };

export const fieldLabel = 'text-[13px] font-medium';
export const fieldLabelStyle = { color: 'var(--ink-muted)' };

export const panelStyle = { background: 'var(--surf-surface)', borderColor: 'var(--surf-line)' };

export const errMessage = (err, fallback) =>
  err?.response?.data?.error || err?.response?.data?.detail || fallback;

export const initialsOf = (name, email) => {
  if (name) {
    return name.split(/\s+/).filter(Boolean).map(w => w[0]).slice(0, 2).join('').toUpperCase();
  }
  return (email || '?').charAt(0).toUpperCase();
};

export const formatDate = (iso, withTime = false) => {
  if (!iso) return '—';
  // D1 returns "YYYY-MM-DD HH:MM:SS" in UTC without a zone marker.
  const d = new Date(iso.includes('T') ? iso : `${iso.replace(' ', 'T')}Z`);
  if (Number.isNaN(d.getTime())) return '—';
  const opts = { timeZone: 'Asia/Kuala_Lumpur', day: 'numeric', month: 'short', year: 'numeric' };
  if (withTime) Object.assign(opts, { hour: '2-digit', minute: '2-digit', hour12: false });
  return d.toLocaleString('en-GB', opts) + (withTime ? ' MYT' : '');
};

export const daysUntil = (iso) => {
  if (!iso) return null;
  const d = new Date(iso.includes('T') ? iso : `${iso.replace(' ', 'T')}Z`);
  return Math.ceil((d - Date.now()) / 86400000);
};
